"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeviceDetection = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
/**
 * useDeviceDetection detects if the user has a touch device or a desktop.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#mobile_device_detection
 * @see https://patrickhlauke.github.io/touch/touchscreen-detection/
 */
var useDeviceDetection = function () {
    var _a = tslib_1.__read((0, react_1.useState)(false), 2), isTouchDevice = _a[0], setIsTouchDevice = _a[1];
    var _b = tslib_1.__read((0, react_1.useState)(true), 2), isDesktop = _b[0], setIsDesktop = _b[1];
    (0, react_1.useEffect)(function () {
        if (typeof window === 'undefined') {
            return;
        }
        if (window.PointerEvent && 'maxTouchPoints' in navigator) {
            if (navigator.maxTouchPoints > 0) {
                setIsTouchDevice(true);
                setIsDesktop(false);
            }
        }
        else {
            if (window.matchMedia &&
                window.matchMedia('(any-pointer:coarse)').matches) {
                setIsTouchDevice(true);
                setIsDesktop(false);
            }
            else if ('ontouchstart' in window) {
                setIsTouchDevice(true);
                setIsDesktop(false);
            }
        }
    }, []);
    return { isTouchDevice: isTouchDevice, isDesktop: isDesktop };
};
exports.useDeviceDetection = useDeviceDetection;
//# sourceMappingURL=use-device-detection.js.map